import React from "react";
import "./Blog.css";
const blog = () => {
  return (
    <div>
      <div className=" mt-3 pb-5">
        <div className="banner-content">
          <h1>Blog</h1>
        </div>
      </div>
    </div>
  );
};

export default blog;
